import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading, Wordmark, cta } from "./_shared";

export default function LandingClosing() {
  return (
    <>
      {/* Two ways to start */}
      <section className="bg-white border-t border-clinical-border/60">
        <div className="mx-auto max-w-5xl px-5 sm:px-8 py-24">
          <SectionHeading eyebrow="Ready when you are">
            Two ways to start — <span className="bg-gradient-to-r from-afyanex-blue to-afyanex-pink bg-clip-text text-transparent">right now.</span>
          </SectionHeading>
          <div className="grid md:grid-cols-2 gap-5">
            <div className="rounded-2xl bg-clinical-bg border border-clinical-border/70 p-7 flex flex-col">
              <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-afyanex-blue">Option 1</div>
              <h3 className="mt-2 font-heading text-2xl font-semibold text-clinical-text">Try it right now, free</h3>
              <p className="mt-2 text-[14.5px] text-clinical-subtext leading-relaxed flex-1">
                Create your agency account in 60 seconds. Full feature access for 14 days.
                No card. No sales call. No waiting.
              </p>
              <Link to="/agency/signup"
                    onClick={cta("final_card", "/agency/signup")}
                    data-testid="landing-cta-final"
                    className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-afyanex-blue px-5 py-3 text-sm font-semibold text-white shadow-[0_12px_28px_-12px_rgba(0,94,255,0.55)] hover:-translate-y-px transition-all">
                Create your agency account <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
            <div className="rounded-2xl bg-clinical-bg border border-clinical-border/70 p-7 flex flex-col">
              <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-afyanex-pink">Option 2</div>
              <h3 className="mt-2 font-heading text-2xl font-semibold text-clinical-text">Book a 30-min walkthrough</h3>
              <p className="mt-2 text-[14.5px] text-clinical-subtext leading-relaxed flex-1">
                We'll show you the console, walk through a real shift, format a sample
                dictation live, and answer every question.
              </p>
              <a href="mailto:hello@afyanex.com?subject=Afyanex demo request"
                 onClick={cta("final_card_demo", "mailto:hello@afyanex.com")}
                 data-testid="landing-cta-demo"
                 className="mt-6 inline-flex items-center justify-center gap-2 rounded-full border border-afyanex-pink/40 text-afyanex-pink px-5 py-3 text-sm font-semibold hover:bg-afyanex-pink hover:text-white transition-all">
                Request demo call <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-clinical-border bg-clinical-bg">
        <div className="mx-auto max-w-6xl px-5 sm:px-8 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Wordmark />
            <span className="text-xs text-clinical-subtext ml-2">© {new Date().getFullYear()} Afyanex Care, Inc.</span>
          </div>
          <nav className="flex items-center gap-5 text-xs text-clinical-subtext">
            <Link to="/pricing" className="hover:text-clinical-text" data-testid="landing-footer-pricing">Pricing</Link>
            <Link to="/privacy" className="hover:text-clinical-text" data-testid="landing-footer-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-clinical-text" data-testid="landing-footer-terms">Terms</Link>
            <a href="mailto:hello@afyanex.com" className="hover:text-clinical-text">Contact</a>
          </nav>
        </div>
      </footer>
    </>
  );
}
